import { render, staticRenderFns } from "./dashboardDanweiPaihang.vue?vue&type=template&id=6d4e14e0&scoped=true"
import script from "./dashboardDanweiPaihang.vue?vue&type=script&lang=js"
export * from "./dashboardDanweiPaihang.vue?vue&type=script&lang=js"
import style0 from "./dashboardDanweiPaihang.vue?vue&type=style&index=0&id=6d4e14e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d4e14e0",
  null
  
)

export default component.exports